import { createJsonHttpRequest, authTokenHandler, zipkinTraceHandler } from "@jutro/transport";
import { getConfigValue } from "@jutro/config";
var zipkinHandler = zipkinTraceHandler("TSM", "Jutro with TSM");
export var createTSMRequest = function (serverUrl) {
  return createJsonHttpRequest(serverUrl, !1).addHandler(zipkinHandler).addHandler(authTokenHandler);
};
export var isTSMEnabled = function () {
  return getConfigValue("JUTRO_AUTH_ENABLED", !1) && getConfigValue("JUTRO_TSM_ENABLED", !1);
};